import type { Button, Buttons as ButtonsData } from '@content-scheduler/shared/render';
import { linkProps } from '../links';
import styles from './parts.module.css';

const hasLabel = (button: Button | null): button is Button => Boolean(button?.label.trim());

export function Buttons({ buttons, className }: { buttons: ButtonsData; className?: string }) {
    const secondary = buttons.secondary.filter(hasLabel);
    if (!hasLabel(buttons.primary) && secondary.length === 0) return null;

    return (
        <div className={[styles.actions, className].filter(Boolean).join(' ')}>
            {hasLabel(buttons.primary) && (
                <a
                    {...linkProps(buttons.primary.link)}
                    className={`${styles.button} ${styles.primary}`}
                    data-button-id={buttons.primary.id}
                >
                    {buttons.primary.label}
                </a>
            )}
            {secondary.map((button) => (
                <a
                    key={button.id}
                    {...linkProps(button.link)}
                    className={`${styles.button} ${styles.secondary}`}
                    data-button-id={button.id}
                >
                    {button.label}
                </a>
            ))}
        </div>
    );
}
